var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.is3DView())?_c('OlMesurePlugin',{attrs:{"plugin":_vm.plugin}}):_c('CesiumMesurePlugin',{attrs:{"plugin":_vm.plugin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }